<template>
  <div>
    <div class="hero-header">
      <img :src="head_service" width="100%" class="hero-img"></img>
      <div class="hero-overlay">
        <p class="hero-title">服务与支持</p>
        <p class="hero-sub">专业服务 · 用心支持</p>
      </div>
    </div>
    <div class="section intro-section">
      <div class="section-title-row">
        <span class="title-bar"></span>
        <p class="title-text">在线服务</p>
      </div>
      <p class="intro-desc">若您在使用本公司产品时遇到任何问题，您可以拨打服务热线或通过在线咨询寻求帮助，我们将为您提供专门的售前购买咨询服务，以及全面的技术售后服务。</p>
    </div>
    <div class="section service-section">
      <div class="section-title-row">
        <span class="title-bar"></span>
        <p class="title-text">服务内容</p>
      </div>
      <div class="service-grid">
        <div class="service-card">
          <div class="card-icon-wrapper" style="background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);">
            <helpcenter theme="outline" size="28" fill="#1a56b8" :strokeWidth="3"/>
          </div>
          <p class="card-title">售前咨询</p>
          <p class="card-desc">产品演示、方案定制、需求分析</p>
        </div>
        <div class="service-card">
          <div class="card-icon-wrapper" style="background: linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%);">
            <ad-product theme="outline" size="28" fill="#059669" :strokeWidth="3"/>
          </div>
          <p class="card-title">技术实施</p>
          <p class="card-desc">系统部署、数据迁移、定制开发</p>
        </div>
        <div class="service-card">
          <div class="card-icon-wrapper" style="background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 100%);">
            <concept-sharing theme="outline" size="28" fill="#ff976a" :strokeWidth="3"/>
          </div>
          <p class="card-title">培训服务</p>
          <p class="card-desc">操作培训、管理培训、定制课程</p>
        </div>
        <div class="service-card">
          <div class="card-icon-wrapper" style="background: linear-gradient(135deg, #f3e8ff 0%, #e9d5ff 100%);">
            <phone-call theme="outline" size="28" fill="#7c3aed" :strokeWidth="3"/>
          </div>
          <p class="card-title">售后服务</p>
          <p class="card-desc">技术支持、问题排查、版本升级</p>
        </div>
      </div>
    </div>
    <div class="section contact-section">
      <div class="section-title-row">
        <span class="title-bar"></span>
        <p class="title-text">联系我们</p>
      </div>
      <div class="contact-info">
        <div class="contact-item">
          <phone-call theme="outline" size="22" fill="#1a56b8" :strokeWidth="3"/>
          <div>
            <p class="contact-label">服务热线</p>
            <p class="contact-value">15710118988</p>
          </div>
        </div>
        <div class="contact-item">
          <send theme="outline" size="22" fill="#1a56b8" :strokeWidth="3"/>
          <div>
            <p class="contact-label">电子邮箱</p>
            <p class="contact-value">linfeng_guo@163.com</p>
          </div>
        </div>
        <div class="contact-item">
          <local theme="outline" size="22" fill="#1a56b8" :strokeWidth="3"/>
          <div>
            <p class="contact-label">公司地址</p>
            <p class="contact-value">上海市青浦区徐泾镇徐详路368号8090青创基地4009室</p>
          </div>
        </div>
        <div class="contact-item">
          <time theme="outline" size="22" fill="#1a56b8" :strokeWidth="3"/>
          <div>
            <p class="contact-label">服务时间</p>
            <p class="contact-value">周一至周五 9:00 - 18:00</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { Helpcenter, AdProduct, ConceptSharing, PhoneCall, Send, Local, Time } from '@icon-park/vue'
  
  export default {
    components: { Helpcenter, AdProduct, ConceptSharing, PhoneCall, Send, Local, Time },
    data() {
      return {
        head_service: require('@/assets/head_service.jpg')
      }
    }
  }
</script>

<style lang="less" scoped>
  .hero-header {
    position: relative;

    .hero-img {
      display: block;
    }

    .hero-overlay {
      position: absolute;
      inset: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: linear-gradient(180deg, rgba(20, 28, 46, 0.2) 0%, rgba(20, 28, 46, 0.65) 100%);

      .hero-title {
        font-size: 42px;
        font-weight: 800;
        color: #fff;
        letter-spacing: 4px;
        text-shadow: 0 2px 16px rgba(0, 0, 0, 0.3);
        margin-bottom: 10px;
      }

      .hero-sub {
        font-size: 18px;
        color: rgba(255, 255, 255, 0.8);
        letter-spacing: 2px;
      }
    }
  }

  .section {
    padding: 60px 12%;

    .section-title-row {
      display: flex;
      align-items: center;
      margin-bottom: 28px;

      .title-bar {
        width: 4px;
        height: 24px;
        background: linear-gradient(180deg, #1a56b8 0%, #3b82f6 100%);
        border-radius: 2px;
        margin-right: 14px;
        flex-shrink: 0;
      }

      .title-text {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        letter-spacing: 1px;
      }
    }
  }

  .intro-section {
    .intro-desc {
      font-size: 16px;
      line-height: 2;
      color: #4b5563;
      padding: 30px 40px;
      background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
      border-radius: 16px;
      border: 1px solid rgba(26, 86, 184, 0.06);
    }
  }

  .service-section {
    background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);

    .service-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px;
    }

    .service-card {
      padding: 36px 24px;
      background: #fff;
      border-radius: 18px;
      text-align: center;
      box-shadow: 0 2px 16px rgba(0, 0, 0, 0.04);
      border: 1px solid #f1f5f9;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        transform: translateY(-6px);
        box-shadow: 0 16px 40px rgba(26, 86, 184, 0.1);
        border-color: rgba(26, 86, 184, 0.2);
      }

      .card-icon-wrapper {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 20px;
        transition: transform 0.4s ease;
      }

      &:hover .card-icon-wrapper {
        transform: scale(1.1);
      }

      .card-title {
        font-size: 18px;
        font-weight: 700;
        color: #1f2937;
        margin-bottom: 10px;
      }

      .card-desc {
        font-size: 14px;
        color: #6b7280;
        line-height: 1.6;
      }
    }
  }

  .contact-section {
    .contact-info {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    .contact-item {
      display: flex;
      align-items: center;
      gap: 18px;
      padding: 22px 28px;
      background: #fff;
      border-radius: 14px;
      box-shadow: 0 2px 12px rgba(0, 0, 0, 0.03);
      border: 1px solid #f1f5f9;
      transition: all 0.3s ease;

      &:hover {
        box-shadow: 0 4px 20px rgba(26, 86, 184, 0.08);
        border-color: rgba(26, 86, 184, 0.15);
      }

      .contact-label {
        font-size: 13px;
        color: #9ca3af;
        margin-bottom: 4px;
      }

      .contact-value {
        font-size: 16px;
        color: #1f2937;
        font-weight: 600;
      }
    }
  }

  @media (max-width: 1024px) {
    .service-section .service-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 640px) {
    .section {
      padding: 40px 5%;
    }

    .hero-header .hero-overlay .hero-title {
      font-size: 28px;
    }

    .service-section .service-grid {
      grid-template-columns: 1fr;
    }
  }
</style>